<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 100 100" class="fill-current">
        <g id="SVGRepo_iconCarrier">
            <title>Ecommerce</title>
            <polygon
                points="80 48.04 80 92.04 74 92.04 74 73.29 62.26 73.29 62.26 54.29 38.26 54.29 38.26 73.29 26 73.29 26 92.04 20 92.04 20 48.04 80 48.04"
                fill="#a28b6d" />
            <polygon points="66.5 74.19 66.5 84.19 62 80.02 57.5 84.19 57.5 74.19 66.5 74.19" fill="#f1b15a" />
            <polygon points="54.76 55.19 54.76 65.19 50.26 61.02 45.76 65.19 45.76 55.19 54.76 55.19" fill="#f1b15a" />
            <polygon points="42.5 74.19 42.5 84.19 38 80.02 33.5 84.19 33.5 74.19 42.5 74.19" fill="#f1b15a" />
            <rect x="20" y="47.04" width="60" height="2" fill="#965706" />
            <path
                d="M91,93H79V35H21V93H9V35H5V25.37l0.62-.25L50,7l0.38,0.15L95,25.37V35H91V93ZM81,91h8V33h4V26.71L50,9.12,7,26.71V33h4V91h8V33H81V91Z"
                fill="#965706" />
        </g>
    </svg>
</template>